import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { DragSelectionModule } from "../../directives/drag-selection";
import { VirtualScrollComponent } from "./virtual-scroll.component";

@NgModule({
  declarations: [VirtualScrollComponent],
  imports: [CommonModule, DragSelectionModule],
  exports: [VirtualScrollComponent],
})
export class VirtualScrollModule { }
